import React, { FunctionComponent, Suspense } from 'react'

import Modal from 'react-modal'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { createGlobalStyle, ThemeProvider } from 'styled-components'
import { ThemeProvider as ThemeUIThemeProvider } from 'theme-ui'

import { theme, themeUI, Spinner } from '@fairhq/common'
import AppContent from 'AppContent'
import { AuthProvider } from 'auth/AuthProvider'
import { AuthError } from 'features/authError/AuthError'
import { useCacheBuster } from 'hooks/use-cache-buster'

Modal.setAppElement('#root')

const GlobalStyle = createGlobalStyle`
  body {
    font-feature-settings: "liga", "kern";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .ReactModal__Overlay {
    background: rgba(21, 28, 40, 80%) !important;
    padding: 80px 40px !important;
    display: flex;
    justify-content: center;
    max-height: 100%;
    overflow: auto !important;
    z-index: 1;
    opacity: 0;
    transition: opacity 200ms ease-in-out;
  }
  .ReactModal__Content {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    position: relative !important;
    max-width: 740px !important;
    width: 100% !important;
    overflow: initial !important;
    margin: 0;
    inset: 0 !important;
    opacity: 0;
    transition: opacity 200ms ease-in-out;
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;
  }
  .ReactModal__Overlay--before-close {
    opacity: 0;
  }

  .ReactModal__Content--after-open {
    opacity: 1;
  }
  .ReactModal__Content--before-close {
    opacity: 0;
  }
`

const App: FunctionComponent = () => {
  useCacheBuster()

  return (
    <Suspense fallback={<Spinner center />}>
      <Router>
        <AuthProvider>
          <ThemeUIThemeProvider theme={themeUI}>
            <ThemeProvider theme={theme}>
              <GlobalStyle />
              <Routes>
                <Route path="/auth" element={<AuthError />} />
                <Route path="*" element={<AppContent />} />
              </Routes>
            </ThemeProvider>
          </ThemeUIThemeProvider>
        </AuthProvider>
      </Router>
    </Suspense>
  )
}

export default React.memo(App)
